// NOTE: hooks
import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom' //using v6 here.

const useDataAuth = () => {
	const user = localStorage.getItem('user')
	const navigate = useNavigate()
	const [urlParams] = useSearchParams()
	const [online, setOnline] = useState(window.navigator.onLine)
	const [loading, setLoading] = useState(true)
	const [shouldRedirect, setShouldRedirect] = useState(false)

	// NOTE: get route trying to be accessed to authorise authenticated users
	const link: any = urlParams.get('redirect')
	const route = 'staff'

	const [display, setDisplay] = useState(
		urlParams.get('resetPwd') ? 'SET_PASSWORD' : 'REGISTER'
	)

	const handlePasswordDisplay = () => setDisplay('RESET_PASSWORD')
	const handleLoginDisplay = () => setDisplay('LOGIN')
	const handleRegisterDisplay = () => setDisplay('REGISTER')

	// NOTE: method to update set online with the current connection status
	const refresh = () => setOnline(window.navigator.onLine)

	// NOTE: hook to check when the page goes offline
	useEffect(() => {
		setLoading(false)

		function handleNetworkChange() {
			setOnline(window.navigator.onLine)
		}

		window.addEventListener('offline', handleNetworkChange)
		window.addEventListener('online', handleNetworkChange)

		if (user) {
			setShouldRedirect(true)
		}

		return () => {
			window.removeEventListener('offline', handleNetworkChange)
			window.removeEventListener('online', handleNetworkChange)
		}
	}, [])

	// NOTE: send them to the redirect search instead of showing them login when they're already logged in
	const redirectAuthenticatedUser = () => {
		// NOTE: Redirect to staff dashboard when no redirect link provided
		if (!urlParams.get('redirect')) return navigate('/')

		// NOTE: check authorisation for the route the authenticated user is trying to accessv
		switch (route) {
			case 'staff':
				return navigate(link)
			default:
				return navigate('/') // NOTE: send to staff dash when unrecognised route
		}
	}

	return {
		loading,
		display,
		route,
		online,
		shouldRedirect,
		handleRegisterDisplay,
		handleLoginDisplay,
		handlePasswordDisplay,
		redirectAuthenticatedUser,
		refresh
	}
}
export default useDataAuth
